import { render, staticRenderFns } from "./STimetableGrid.vue?vue&type=template&id=08dbba69&scoped=true&"
import script from "./STimetableGrid.vue?vue&type=script&lang=js&"
export * from "./STimetableGrid.vue?vue&type=script&lang=js&"
import style0 from "./STimetableGrid.vue?vue&type=style&index=0&id=08dbba69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dbba69",
  null
  
)

export default component.exports